import { PricedProduct } from '@common/models';

export const getPromotionEndDate = (products: PricedProduct[]): string | undefined => {
    const FIRST_INDEX = 0;
    const endDate = products
        .filter((product) => product.expirationPromotionDate)
        .map((product) => product.expirationPromotionDate as Date)
        .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())[FIRST_INDEX];

    return endDate && new Date(endDate).toISOString();
};
